import React, {Fragment} from "react";
import 'spinkit/css/spinkit.css';

export default class LoadingSpinnerComponent extends React.Component {
  render() {

    let type = this.props.type || "wave";

    return <Fragment>
      {
        type === "wave" && <div className="sk-wave">
          <div className="sk-rect sk-rect1"></div>
          &nbsp;
          <div className="sk-rect sk-rect2"></div>
          &nbsp;
          <div className="sk-rect sk-rect3"></div>
          &nbsp;
          <div className="sk-rect sk-rect4"></div>
          &nbsp;
          <div className="sk-rect sk-rect5"></div>
        </div>
      }
      {
        type === "circle" && <div className="sk-circle">
          <div className="sk-circle1 sk-child"></div>
          <div className="sk-circle2 sk-child"></div>
          <div className="sk-circle3 sk-child"></div>
          <div className="sk-circle4 sk-child"></div>
          <div className="sk-circle5 sk-child"></div>
          <div className="sk-circle6 sk-child"></div>
          <div className="sk-circle7 sk-child"></div>
          <div className="sk-circle8 sk-child"></div>
          <div className="sk-circle9 sk-child"></div>
          <div className="sk-circle10 sk-child"></div>
          <div className="sk-circle11 sk-child"></div>
          <div className="sk-circle12 sk-child"></div>
        </div>
      }
      {
        this.props.message && this.props.message.length>0 && <div style={{textAlign:"center"}}>{this.props.message}</div>
      }
    </Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSpinnerComponent.js